import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ProductRange from "../components/ProductRange";
import Gallery from "../components/Gallery";
import ResearchDev from "../components/ResearchDev";
import Industries from "../components/Industries";
import Dealership from "../components/Dealership";
import TrustedBy from "../components/TrustedBy";
import GlobalReach from "../components/GlobalReach";
import Sustainability from "../components/Sustainability";
import Blogs from "../components/Blogs";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ProductRange />
        <Gallery />
        <ResearchDev />
        <Industries />
        <Dealership />
        <TrustedBy />
        <GlobalReach />
        <Sustainability />
        <Blogs />
      </main>
      <Footer />
    </>
  );
}
